import { PostAggregateBusinessToGroupRequest } from '@/coreInfrastructureModule/axios/generated/groupManage';

/**
 * 集計をグループに追加するアダプタ
 */
export class PostAggregateBusinessGroupAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param aggregateBusinessIds - 集計ID
   * @param groupId - グループID
   */
  public static adaptForRequest(aggregateBusinessIds: string[], groupId: string): PostAggregateBusinessToGroupRequest {
    return {
      postAggregateBusinessToGroupInfo: {
        aggregateBusinessIds: aggregateBusinessIds,
        groupId: groupId,
      },
    };
  }
}
